export const RISK_SCORE_COLORS = {
  high: '#3BA272',
  mid: '#F5A623',
  low: '#BC4E4E',
}

export const RISK_CHART_LINE = '#245CA6'

export const CORRELATION_HEATMAP = {
  positive: '#D9534F',
  negative: '#3BA272',
  neutral: '#ffffff',
  positiveRgb: '217, 83, 79',
  negativeRgb: '59, 162, 114',
}

export const REPORT_PALETTE = [
  '#80CF95',
  '#238210',
  '#0093DB',
  '#003F5E',
  '#FFB520',
  '#D89919',
  '#F5A36A',
  '#F47721',
  '#519EA5',
  '#3B7378',
  // '#AAABE2',
  // '#FFBB00',
  // '#65CB3B',
  // '#6C757D',
  // '#FF8F00',
  // '#2D6727',
  // '#644D40',
  // '#F6E89F',
  // '#7FB97F',
  // '#645E9D',
  // '#2FB89F',
  // '#986F4B',
  // '#E75735',
  // '#6E1100',
  // '#2E86AB',
  // '#374459',
]
